export default "__VITE_ASSET__CTYs_zPy__"